var _path, _polygon, _polygon2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompany = function SvgCompany(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,14c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3S14.3,14,16,14z M8,14c1.7,0,3-1.3,3-3S9.7,8,8,8s-3,1.3-3,3S6.3,14,8,14z  M8,16c-2.3,0-7,1.2-7,3.5V22h14v-2.5C15,17.2,10.3,16,8,16z M16,16c-0.3,0-0.6,0-1,0c1.2,0.8,2,2,2,3.5V22h6v-2.5 C23,17.2,18.3,16,16,16z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12,1 1,7 1,9 12,3  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "14,2.1 14,4.1 23,9 23,7  "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompany, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company.7d13e4f1.svg";
export { ForwardRef as ReactComponent };